import React, { FC, useEffect, useRef, useState } from "react";
import SearchBar from "./SearchBar";
import MobileSearch from "./MobileSearch";
import { useData } from "data/data-provider";
import RenterInfo from "./RenterInfo";
import DriverInfo from "./DriverInfo";
import toast from "react-hot-toast";
import VehicleSwap from "./VehicleSwap";
import { getCustomer } from "api/customer/customer";
import InsuranceandExtras from "./InsuranceandExtras";

interface EditBookingProps {
  bookingDetails: any;
  startTime: any;
  endTime: any;
  setStartTime: any;
  setEndTime: any;
}

const EditBooking: FC<EditBookingProps> = ({
  bookingDetails,
  startTime,
  endTime,
  setStartTime,
  setEndTime,
}) => {
  const [selected, setSelected] = useState("Trip Info");
  const options = [
    "Trip Info",
    "Insurance & Extras",
    "Vehicle Swap",
    "Renter Info",
    "Add Driver",
  ];

  useEffect(() => {
    const fetchCustomer = async () => {
      try {
        const response = await getCustomer(bookingDetails?.customer.email);
        if (response) {
          localStorage.setItem("access_token", response.access_token);
          localStorage.setItem("refresh_token", response.refresh_token);
          localStorage.setItem("user", JSON.stringify(response));
        }
      } catch (err) {
        toast.error("An error occurred while processing your request.");
      }
    };
    fetchCustomer();
  }, []);

  return (
    <div className="border border-dotted my-4 p-3 md:p-6">
      <div className="flex items-center justify-between bg-secondary-100 rounded-md shadow-sm">
        {options.map((option) => (
          <button
            key={option}
            onClick={() => setSelected(option)} // Update the selected state
            className={`ttnc-ButtonPrimary text-button-color hover:ring-primary-6000 hover:ring-offset-2 hover:ring-2 px-1 md:px-6 py-2 text-xs md:text-sm font-semibold rounded-md ${
              selected === option
                ? "bg-primary-100  border-primary-200 text-button-color shadow-black/10 shadow-lg"
                : " text-text-color"
            }`}
          >
            {option}
          </button>
        ))}
      </div>
      {selected === "Trip Info" && (
        <>
          <div className="hidden lg:flex">
            <SearchBar
              startTime={startTime}
              setStartTime={setStartTime}
              endTime={endTime}
              setEndTime={setEndTime}
              bookingDetails={bookingDetails}
            />
          </div>
          <div className="flex lg:hidden  mt-4">
            <MobileSearch
              startTime={startTime}
              setStartTime={setStartTime}
              endTime={endTime}
              setEndTime={setEndTime}
              bookingDetails={bookingDetails}
            />
          </div>
        </>
      )}
      {selected === "Vehicle Swap" && (
        <>
          <VehicleSwap bookingDetails={bookingDetails} />
        </>
      )}
      {selected === "Insurance & Extras" && (
        <>
          <InsuranceandExtras bookingDetails={bookingDetails} />
        </>
      )}
      {selected === "Renter Info" && (
        <>
          <RenterInfo bookingDetails={bookingDetails} />
        </>
      )}
      {selected === "Add Driver" && (
        <>
          <DriverInfo bookingDetails={bookingDetails} />
        </>
      )}
    </div>
  );
};

export default EditBooking;
